import { RootState } from '../';

export const selectFaqs = (state: RootState) => state.faqs.list;

export const selectFaqsLoading = (state: RootState) => state.faqs.isLoading;